"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StandardId;
(function (StandardId) {
    StandardId[StandardId["CARD_TYPHOON"] = 3670016] = "CARD_TYPHOON";
    StandardId[StandardId["CARD_RUSH"] = 3670054] = "CARD_RUSH";
    StandardId[StandardId["CARD_AUTO_TACKLE"] = 3670018] = "CARD_AUTO_TACKLE";
    StandardId[StandardId["CARD_RANDOM"] = 3670056] = "CARD_RANDOM";
    StandardId[StandardId["CARD_TACKLE_POWER_UP"] = 3670020] = "CARD_TACKLE_POWER_UP";
    StandardId[StandardId["CARD_SWING_POWER_UP"] = 3670058] = "CARD_SWING_POWER_UP";
    StandardId[StandardId["CARD_SIDE_ATTACK"] = 3670022] = "CARD_SIDE_ATTACK";
    StandardId[StandardId["CARD_CHASING"] = 3670060] = "CARD_CHASING";
    StandardId[StandardId["CARD_LEFT"] = 3670024] = "CARD_LEFT";
    StandardId[StandardId["CARD_RIGHT"] = 3670062] = "CARD_RIGHT";
    StandardId[StandardId["CARD_FRONT"] = 3670026] = "CARD_FRONT";
    StandardId[StandardId["CARD_BACK"] = 3670064] = "CARD_BACK";
    StandardId[StandardId["CARD_GO"] = 3670028] = "CARD_GO";
    StandardId[StandardId["SKUNK_BLUE"] = 3670078] = "SKUNK_BLUE";
    StandardId[StandardId["SKUNK_GREEN"] = 3670042] = "SKUNK_GREEN";
    StandardId[StandardId["SKUNK_YELLOW"] = 3670080] = "SKUNK_YELLOW";
    StandardId[StandardId["SKUNK_ORANGE"] = 3670044] = "SKUNK_ORANGE";
    StandardId[StandardId["SKUNK_RED"] = 3670082] = "SKUNK_RED";
    StandardId[StandardId["SKUNK_BROWN"] = 3670046] = "SKUNK_BROWN";
    StandardId[StandardId["STICKER_SPEED_UP"] = 3670066] = "STICKER_SPEED_UP";
    StandardId[StandardId["STICKER_SPEED_DOWN"] = 3670030] = "STICKER_SPEED_DOWN";
    StandardId[StandardId["STICKER_WOBBLE"] = 3670068] = "STICKER_WOBBLE";
    StandardId[StandardId["STICKER_PANIC"] = 3670032] = "STICKER_PANIC";
    StandardId[StandardId["STICKER_SPIN"] = 3670070] = "STICKER_SPIN";
    StandardId[StandardId["STICKER_SHOCK"] = 3670034] = "STICKER_SHOCK";
    StandardId[StandardId["MARK_CRAFT_FIGHTER"] = 3670048] = "MARK_CRAFT_FIGHTER";
    StandardId[StandardId["MARK_RHYTHM_AND_GO"] = 3670052] = "MARK_RHYTHM_AND_GO";
    StandardId[StandardId["MARK_SKUNK_CHASER"] = 3670086] = "MARK_SKUNK_CHASER";
    StandardId[StandardId["MARK_FINGER_STRIKE"] = 3670050] = "MARK_FINGER_STRIKE";
    StandardId[StandardId["MARK_FINGER_STRIKE_1P"] = 3670088] = "MARK_FINGER_STRIKE_1P";
    StandardId[StandardId["MARK_FREE_MOVE"] = 3670084] = "MARK_FREE_MOVE";
})(StandardId = exports.StandardId || (exports.StandardId = {}));
//# sourceMappingURL=standard-id.js.map